import type { IGrowthOverviewTableRow } from "../types";
import { GrowthOverviewLevel } from "../types";

import { collectSingleChildExpansionIds } from "./collectSingleChildExpansionIds";
import { isGrowthOverviewRowExpandable } from "./isGrowthOverviewRowExpandable";

export const getAutoExpandedRowKeys = (
    rows: IGrowthOverviewTableRow[],
    responseLevel?: GrowthOverviewLevel,
): ReadonlySet<string> | null => {
    const expandableRows = rows.filter(isGrowthOverviewRowExpandable);

    if (expandableRows.length === 1) {
        const singleRow = expandableRows[0];
        if (singleRow.children?.length) {
            return new Set(collectSingleChildExpansionIds(singleRow));
        }

        return new Set([singleRow.id]);
    }

    if (responseLevel === GrowthOverviewLevel.SubIndustries && rows.length === 1) {
        const singleRow = rows[0];
        if (singleRow.rowType === "sub-industry" && isGrowthOverviewRowExpandable(singleRow)) {
            return new Set([singleRow.id]);
        }
    }

    if (responseLevel === GrowthOverviewLevel.Industries && rows.length === 1) {
        const singleRow = rows[0];
        if (singleRow.rowType === "industry" && isGrowthOverviewRowExpandable(singleRow)) {
            if (singleRow.children?.length) {
                return new Set(collectSingleChildExpansionIds(singleRow));
            }

            return new Set([singleRow.id]);
        }
    }

    return null;
};
